// extracted by mini-css-extract-plugin
export var background = "HeroAlt-module--background--40d66";
export var content = "HeroAlt-module--content--7d61a";
export var heroAlt = "HeroAlt-module--heroAlt--39fa0";
export var mediaContainer = "HeroAlt-module--mediaContainer--8e42e";
export var mediaOuter = "HeroAlt-module--mediaOuter--f6a71";
export var overlay = "HeroAlt-module--overlay--11a63";
export var video = "HeroAlt-module--video--12dd5";
export var videoElement = "HeroAlt-module--videoElement--e2d88";
export var videoWrapper = "HeroAlt-module--videoWrapper--d7fa0";